import React, { useState } from 'react';
import '../styles/SaveChartModal.css';

const SaveChartModal = ({ isOpen, onClose, onSave, isLoading = false }) => {
  const [chartName, setChartName] = useState('');
  const [error, setError] = useState('');

  const handleSave = async () => {
    // Validate chart name
    if (!chartName.trim()) {
      setError('Please enter a chart name');
      return;
    }

    if (chartName.length > 100) {
      setError('Chart name must be 100 characters or less');
      return;
    }

    setError('');
    await onSave(chartName);
    setChartName('');
  };

  const handleClose = () => {
    setChartName('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="save-chart-modal-overlay">
      <div className="save-chart-modal">
        <div className="save-chart-header">
          <h2>💾 Save Chart</h2>
          <button className="save-chart-close-btn" onClick={handleClose}>✕</button>
        </div>

        <div className="save-chart-body">
          <label htmlFor="chart-name" className="save-chart-label">
            Enter a name for this chart:
          </label>
          <input
            id="chart-name"
            type="text"
            className="save-chart-input"
            placeholder="e.g., My Birth Chart - John Doe"
            value={chartName}
            onChange={(e) => setChartName(e.target.value)}
            maxLength="100"
            disabled={isLoading}
            onKeyPress={(e) => e.key === 'Enter' && handleSave()}
          />
          <div className="char-count">
            {chartName.length} / 100 characters
          </div>

          {error && (
            <div className="save-chart-error">
              ⚠️ {error}
            </div>
          )}
        </div>

        <div className="save-chart-footer">
          <button
            className="save-chart-cancel-btn"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="save-chart-submit-btn"
            onClick={handleSave}
            disabled={isLoading || !chartName.trim()}
          >
            {isLoading ? '💫 Saving...' : '✓ Save Chart'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveChartModal;
